module.exports = __webpack_public_path__ + "img/xmasParty13.7ebdb486.jpg";